import React, { useState } from 'react';

import AccountVolunteeringTableEmpty from '../account-volunteering-table-empty/AccountVolunteeringTableEmpty';
import AccountVolunteeringTable from '../account-volunteering-table/AccountVolunteeringTable';
import './AccountVolunteering.css';

export default function AccountVolunteering(props) {

  const leadingColor = props.partner.partnerConfig.leadingColor;
  const [hasData, setHasData] = useState(true);

  return (
    <>
        {hasData
          ? <AccountVolunteeringTable partner={props.partner} leading_color={leadingColor} onEmpty={() => setHasData(false)}/>
          : <AccountVolunteeringTableEmpty/>
        }
    </>
  )
}
